import { Users } from "lucide-react";
import { Button } from "@/components/ui/button";

const CoFounderBanner = () => {
  return (
    <section className="bg-gradient-to-r from-ocean-500 to-eco-600 py-10 md:py-16 px-4 md:px-6">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-3 rounded-full">
              <Users className="h-8 w-8 text-white" />
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">
            Join Us as a Co-Founder
          </h2>
          <p className="text-base md:text-lg text-white/90 mb-6 md:mb-8">
            We're building Ourcelium as a Community Interest Company (CIC) and looking for a co-founder 
            or two to help bring this vision to life. We can provide funding support, but we need passionate 
            collaborators who share our commitment to sustainability. If you're ready to make a real impact, 
            we'd love to hear from you.
          </p>
          <Button 
            asChild
            className="bg-white text-ocean-600 hover:bg-white/90 hover:text-ocean-700"
          >
            <a href="mailto:chat@ourcelium.co.uk">Get in Touch</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CoFounderBanner;
